document.addEventListener("DOMContentLoaded", function () {
  updateProductAddOnTitle();
  
  const videos = document.querySelectorAll(".custom-video");
  const buttons = document.querySelectorAll(".play-pause-button");

  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      const video = this.previousElementSibling;

      // Pause all other videos
      videos.forEach((v) => {
        if (v !== video && !v.paused) {
          v.pause();
          v.nextElementSibling.textContent = "▶"; // Reset other buttons to play icon
        }
      });

      // Play or pause the clicked video
      if (video.paused) {
        video.play();
        this.textContent = "❚❚"; // Change the button to pause icon
      } else {
        video.pause();
        this.textContent = "▶"; // Change the button back to play icon
      }
    });
  });

  // Update button state when video plays or pauses
  videos.forEach((video) => {
    video.addEventListener("play", function () {
      this.nextElementSibling.textContent = "❚❚";
    });

    video.addEventListener("pause", function () {
      this.nextElementSibling.textContent = "▶";
    });
  });
});

function updateProductAddOnTitle() {
  // Select the section with the data-template attribute
  var productSection = document.querySelector("section[data-template]");

  // Ensure the section element exists
  if (productSection) {
    var templateName = productSection.getAttribute("data-template");

    function updateUpsellTitle() {
      var upsellTitle = document.querySelector(".lb-upsell-ppa-title");

      if (upsellTitle) {
        // Check and update the title only if it doesn't match the expected value
        if (templateName === "product.foundation" && upsellTitle.textContent !== "Save 15% When You Add a Mattress:") {
          upsellTitle.textContent = "Save 15% When You Add a Mattress:";
        } else if (templateName === "product" && upsellTitle.textContent !== "3. Save 15% When You Add a Base:") {
          upsellTitle.textContent = "3. Save 15% When You Add a Base:";
        }
        return true; // Indicate that the title was found and updated
      }
      return false; // Indicate that the title was not found
    }

    // Initial update to handle the case where the element is already on the page
    if (!updateUpsellTitle()) {
      // If upsell title wasn't found, set up a MutationObserver to watch for it
      var observer = new MutationObserver(function (mutationsList) {
        for (var mutation of mutationsList) {
          if (
            mutation.type === "childList" &&
            mutation.addedNodes.length > 0
          ) {
            mutation.addedNodes.forEach(function(node) {
              if (
                node.querySelector &&
                node.querySelector(".lb-upsell-ppa-title")
              ) {
                if (updateUpsellTitle()) {
                  observer.disconnect(); // Stop observing once the title is updated
                }
              }
            });
          }
        }
      });

      // Start observing only the specific section for child elements being added
      observer.observe(productSection, {
        childList: true,
        subtree: true,
      });
    }
  } else {
    console.error("Product section with data-template attribute not found.");
  }
}